// Inventário Cíclico · lista do dia + contagem cega + acuracidade
import { db, auth } from '../client.js';
import { escapeHTML, QTY, DATE, DT, NUM, SHORT } from '../shared.js';

export async function viewInventario($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">ACURACIDADE OPERACIONAL</div>
        <h1>Inventário <strong>cíclico</strong></h1>
        <p class="lead">Programação automática A=mensal · B=trimestral · C=semestral. Contagem cega: operador conta sem ver o saldo do sistema. Divergência abre exceção PDCA.</p>
      </div>
      <div class="page-head-actions">
        <button class="btn" id="btn-gerar">⟳ Gerar lista do dia</button>
      </div>
    </header>

    <div class="stats" id="inv-stats"></div>

    <div class="card">
      <div class="card-head">
        <h2>Lista do dia <span class="count" id="inv-count">…</span></h2>
        <div class="row gap-sm">
          <label class="text-sm">filtro:</label>
          <select id="inv-filter" class="form-stack-inline">
            <option value="">todos</option>
            <option value="hoje">apenas hoje</option>
            <option value="atrasado">atrasados</option>
            <option value="A">classe A</option>
            <option value="B">classe B</option>
            <option value="C">classe C</option>
          </select>
        </div>
      </div>
      <div id="inv-list"></div>
    </div>

    <div class="card mt-md" id="contar-card" style="display:none;">
      <div class="card-head">
        <h2 id="contar-title">Contar SKU</h2>
        <button class="btn-mini" id="btn-close-contar">×</button>
      </div>
      <div id="contar-body"></div>
    </div>

    <div class="grid-2 mt-md">
      <div class="card">
        <div class="card-head"><h2>Acuracidade últimos 30d</h2></div>
        <div id="acur-30d"></div>
      </div>
      <div class="card">
        <div class="card-head"><h2>Acuracidade por mês</h2></div>
        <div id="acur-mensal"></div>
      </div>
    </div>
  `;

  document.getElementById('btn-gerar').addEventListener('click', async () => {
    const btn = document.getElementById('btn-gerar');
    btn.disabled = true; btn.textContent = '⟳ gerando…';
    try {
      const { data, error } = await db.rpc('gerar_lista_inventario_dia');
      if (error) throw error;
      const r = data;
      if (r.ja_existe) {
        alert(`Já há ${r.pendentes} pendentes para ${r.dia}.`);
      } else {
        alert(`✓ ${r.total} SKUs programados (${r.skus_a_programados} A, ${r.skus_b_programados} B, ${r.skus_c_programados} C)`);
      }
      viewInventario($c);
    } catch (e) { alert('Erro: ' + e.message); btn.disabled = false; btn.textContent = '⟳ Gerar lista do dia'; }
  });

  document.getElementById('inv-filter').addEventListener('change', () => loadList());

  await Promise.all([loadStats(), loadList(), loadAcuracidade()]);

  async function loadStats() {
    try {
      const { data: all } = await db.from('vw_inventario_dia').select('situacao,classe_abc,fechado');
      const total = (all || []).length;
      const hoje = (all || []).filter(r => r.situacao === 'hoje').length;
      const atrasado = (all || []).filter(r => r.situacao === 'atrasado').length;
      const fechados = (all || []).filter(r => r.fechado).length;
      const divergentes = (all || []).filter(r => r.situacao === 'divergente').length;
      document.getElementById('inv-stats').innerHTML = `
        <div class="stat"><div class="label">Programadas hoje</div><div class="value">${NUM(hoje)}</div></div>
        <div class="stat ${atrasado > 0 ? 'warning' : ''}"><div class="label">Atrasadas</div><div class="value">${NUM(atrasado)}</div></div>
        <div class="stat success"><div class="label">Concluídas (todas)</div><div class="value">${NUM(fechados)}</div></div>
        <div class="stat ${divergentes > 0 ? 'warning' : 'success'}"><div class="label">Divergentes</div><div class="value">${NUM(divergentes)}</div></div>
        <div class="stat"><div class="label">Total programado</div><div class="value">${NUM(total)}</div></div>
      `;
    } catch (_e) { /* */ }
  }

  async function loadList() {
    const f = document.getElementById('inv-filter').value;
    let q = db.from('vw_inventario_dia').select('*').limit(200);
    if (f === 'hoje' || f === 'atrasado') q = q.eq('situacao', f);
    else if (['A', 'B', 'C'].includes(f)) q = q.eq('classe_abc', f);
    const { data: rows, error } = await q;
    const listEl = document.getElementById('inv-list');
    document.getElementById('inv-count').textContent = (rows || []).length;
    if (error) { listEl.innerHTML = `<div class="empty err">${escapeHTML(error.message)}</div>`; return; }
    if (!rows || rows.length === 0) {
      listEl.innerHTML = '<div class="empty">Sem itens. Clique em <strong>⟳ Gerar lista do dia</strong>.</div>';
      return;
    }
    listEl.innerHTML = `
      <table class="tbl">
        <thead><tr><th>Quando</th><th>Ciclo</th><th>Classe</th><th>SKU</th><th>Descrição</th><th>Endereço</th><th>Estado</th><th></th></tr></thead>
        <tbody>${rows.map(r => `
          <tr>
            <td class="mono text-sm">${DATE(r.proxima_contagem)}</td>
            <td><span class="pill pill-mute">${escapeHTML(r.ciclo)}</span></td>
            <td><span class="pill ${pillClasse(r.classe_abc)}">${r.classe_abc || '·'}${r.classe_xyz || ''}</span></td>
            <td class="mono">${escapeHTML(SHORT(r.sku_codigo, 22))}</td>
            <td>${escapeHTML(SHORT(r.sku_descricao || '—', 40))}</td>
            <td class="mono">${escapeHTML(r.endereco || '—')}</td>
            <td><span class="pill ${pillSitu(r.situacao)}">${r.situacao}</span></td>
            <td>${r.fechado
              ? `<span class="text-mute text-sm">${escapeHTML(r.responsavel || '—')}</span>`
              : `<button class="btn-mini" data-contar="${r.id}" data-sku="${escapeHTML(r.sku_codigo)}">contar →</button>`
            }</td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    listEl.querySelectorAll('[data-contar]').forEach(b => b.addEventListener('click', () => abrirContar(parseInt(b.dataset.contar, 10), b.dataset.sku)));
  }

  async function abrirContar(id, sku) {
    const card = document.getElementById('contar-card');
    const body = document.getElementById('contar-body');
    document.getElementById('contar-title').textContent = `Contagem cega · ${sku}`;
    card.style.display = 'block';
    body.innerHTML = `
      <p class="text-sm text-mute mb-md">Conte fisicamente o SKU no endereço. <strong>Não veja o saldo do sistema</strong> — o sistema mostra a divergência depois.</p>
      <form id="form-contar" class="form-stack" style="max-width:480px;">
        <label>Quantidade contada<input id="ct-qtd" type="number" step="0.01" min="0" required autofocus></label>
        <label>Responsável<input id="ct-resp" placeholder="seu nome" required></label>
        <label>Observações<textarea id="ct-obs" rows="2"></textarea></label>
        <div class="row gap-sm">
          <button type="submit" class="btn btn-green">✓ Registrar contagem</button>
          <button type="button" class="btn-mini" id="ct-cancel">cancelar</button>
        </div>
      </form>
      <div id="ct-result" style="display:none; margin-top:14px;"></div>
    `;
    document.getElementById('ct-cancel').addEventListener('click', () => card.style.display = 'none');
    document.getElementById('form-contar').addEventListener('submit', async (e) => {
      e.preventDefault();
      try {
        const { data: r, error } = await db.rpc('registrar_contagem', {
          p_id: id,
          p_saldo_contado: parseFloat(document.getElementById('ct-qtd').value),
          p_responsavel: document.getElementById('ct-resp').value,
          p_observacoes: document.getElementById('ct-obs').value || null,
        });
        if (error) throw error;
        const result = document.getElementById('ct-result');
        result.style.display = 'block';
        if (r.divergente) {
          result.className = 'msg warn';
          result.innerHTML = `<strong>⚠ Divergência</strong><br>Sistema: ${QTY(r.sistema)} · Contado: ${QTY(r.contado)} · <strong>Dif: ${QTY(r.divergencia)}</strong><br>Exceção registrada em <span class="mono-inline">divergencia</span> · status: aberta.`;
        } else {
          result.className = 'msg ok';
          result.innerHTML = `<strong>✓ Contagem OK</strong> · ${QTY(r.contado)} = sistema.`;
        }
        setTimeout(() => { card.style.display = 'none'; viewInventario($c); }, 2000);
      } catch (err) { alert('Erro: ' + err.message); }
    });
  }

  document.getElementById('btn-close-contar').addEventListener('click', () => {
    document.getElementById('contar-card').style.display = 'none';
  });

  async function loadAcuracidade() {
    try {
      const { data: a30 } = await db.from('vw_acuracidade_30d').select('*').maybeSingle();
      const el = document.getElementById('acur-30d');
      if (!a30 || !a30.contagens) {
        el.innerHTML = '<div class="empty">Sem contagens nos últimos 30 dias.</div>';
      } else {
        const pct = Number(a30.acuracidade_pct || 0);
        const cls = pct >= 99.5 ? 'success' : pct >= 95 ? 'warning' : 'danger';
        el.innerHTML = `
          <div class="acur-big ${cls}">
            <div class="big-num">${pct.toFixed(2)}<span>%</span></div>
            <div class="big-lbl">Meta: 99,5% · ${a30.contagens} contagens · ${a30.divergentes} divergentes</div>
          </div>
          <table class="tbl mt-md">
            <tbody>
              <tr><td>Classe A</td><td class="num strong">${Number(a30.acuracidade_a_pct || 0).toFixed(2)}%</td></tr>
              <tr><td>Classe B</td><td class="num strong">${Number(a30.acuracidade_b_pct || 0).toFixed(2)}%</td></tr>
              <tr><td>Classe C</td><td class="num strong">${Number(a30.acuracidade_c_pct || 0).toFixed(2)}%</td></tr>
            </tbody>
          </table>`;
      }

      const { data: mensal } = await db.from('vw_acuracidade_mensal').select('*').limit(6);
      const m = document.getElementById('acur-mensal');
      if (!mensal || mensal.length === 0) {
        m.innerHTML = '<div class="empty">Sem dados mensais.</div>';
      } else {
        m.innerHTML = `
          <table class="tbl">
            <thead><tr><th>Mês</th><th class="num">Contagens</th><th class="num">OK</th><th class="num">Dif.</th><th class="num">Acuracidade</th></tr></thead>
            <tbody>${mensal.map(r => {
              const pct = Number(r.acuracidade_pct || 0);
              const pcls = pct >= 99.5 ? 'pill-green' : pct >= 95 ? 'pill-amber' : 'pill-red';
              return `<tr>
                <td class="mono">${escapeHTML(r.mes)}</td>
                <td class="num">${NUM(r.contagens_total)}</td>
                <td class="num">${NUM(r.contagens_ok)}</td>
                <td class="num">${NUM(r.contagens_divergentes)}</td>
                <td class="num"><span class="pill ${pcls}">${pct.toFixed(2)}%</span></td>
              </tr>`;
            }).join('')}</tbody>
          </table>`;
      }
    } catch (e) { document.getElementById('acur-30d').innerHTML = `<div class="empty err">${escapeHTML(e.message)}</div>`; }
  }
}

function pillClasse(abc) { return abc === 'A' ? 'pill-solid-blue' : abc === 'B' ? 'pill-blue' : 'pill-mute'; }
function pillSitu(s) {
  return {
    hoje: 'pill-blue',
    atrasado: 'pill-red',
    futuro: 'pill-mute',
    ok: 'pill-green',
    divergente: 'pill-amber',
  }[s] || 'pill-mute';
}
